const zIndices = {
  auto: 'auto',
  navbar: '100',
  mobileNav: '200',
  tooltip: '300',
  modal: '400',
};
export default zIndices;
